import React from "react";
import { useDarkMode } from '../../utils/darkMode';
import { graphql, useStaticQuery } from "gatsby";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2'
import colors from 'tailwindcss/colors'
import Prose from "../utility/prose";

const TaxRate = () => {
    const [darkMode, _] = useDarkMode();

    const brandDark = colors.green[600]
    const brandDarker = colors.green[800]
    const brandLight = colors.green[400]
    const brandDarkerHover = colors.green[700]
    const brandDarkHover = colors.green[500]
    const brandLightHover = colors.green[300]
    const text = colors.neutral[800]
    const gridLinesDark = colors.neutral[300]
    const gridLinesLight = colors.neutral[500]

    const data = useStaticQuery(graphql`
        query {
            allStrapiTaxRate (sort: {year: DESC}) {
                nodes {
                    id
                    year
                    maintenance_operations_rate
                    debt_service_rate
                    contract_rate
                    road_rate
                    order_levying_taxes {
                        localFile {
                            publicURL
                        }
                    }
                }
            }
        }
  `)

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );

    return (
        <Prose>
            {/* <div className="w-full md:w-5/6 lg:w-2/3 mx-auto"> */}
            {/*     <Bar data={{ */}
            {/*         labels: data.allStrapiTaxRate.nodes.map((rate) => { return (rate.year) }).reverse(), */}
            {/*         datasets: [ */}
            {/*             { */}
            {/*                 label: "Debt Service", */}
            {/*                 backgroundColor: brandLight, */}
            {/*                 strokeColor: brandLight, */}
            {/*                 hoverBackgroundColor: brandLightHover, */}
            {/*                 hoverStrokeColor: brandLightHover, */}
            {/*                 data: data.allStrapiTaxRate.nodes.map((rate) => { return (rate.debt_service_rate.toFixed(6)) }).reverse() */}
            {/*             }, */}
            {/*             { */}
            {/*                 label: "Maintenance and Operation", */}
            {/*                 backgroundColor: brandDark, */}
            {/*                 strokeColor: brandDark, */}
            {/*                 hoverBackgroundColor: brandDarkHover, */}
            {/*                 hoverStrokeColor: brandDarkHover, */}
            {/*                 data: data.allStrapiTaxRate.nodes.map((rate) => { return (rate.maintenance_operations_rate.toFixed(6)) }).reverse() */}
            {/*             }, */}
            {/*             // { */}
            {/*             //     label: "Road", */}
            {/*             //     backgroundColor: brandDarker, */}
            {/*             //     strokeColor: brandDarker, */}
            {/*             //     hoverBackgroundColor: brandDarkerHover, */}
            {/*             //     hoverStrokeColor: brandDarkerHover, */}
            {/*             //     data: data.allStrapiTaxRate.nodes.map((rate) => { return (rate.road_rate.toFixed(6)) }).reverse() */}
            {/*             // }, */}
            {/*         ] */}
            {/*     }} */}
            {/*         options={{ */}
            {/*             color: darkMode ? '#FFF' : text, */}
            {/*             responsive: true, */}
            {/*             interaction: { */}
            {/*                 intersect: false, */}
            {/*                 mode: 'point', */}
            {/*             }, */}
            {/*             scales: { */}
            {/*                 x: { */}
            {/*                     grid: { */}
            {/*                         color: darkMode ? gridLinesLight : gridLinesDark, */}
            {/*                     }, */}
            {/*                     ticks: { */}
            {/*                         color: darkMode ? '#FFF' : text, */}
            {/*                     }, */}
            {/*                     stacked: true, */}
            {/*                 }, */}
            {/*                 y: { */}
            {/*                     grid: { */}
            {/*                         color: darkMode ? gridLinesLight : gridLinesDark, */}
            {/*                     }, */}
            {/*                     ticks: { */}
            {/*                         color: darkMode ? '#FFF' : text, */}
            {/*                     }, */}
            {/*                     stacked: true, */}
            {/*                 }, */}
            {/*             }, */}
            {/*             plugins: { */}
            {/*                 tooltip: { */}
            {/*                     callbacks: { */}
            {/*                         label: (ctx) => (`${ctx.dataset.label}: ${ctx.raw}`) */}
            {/*                     } */}
            {/*                 }, */}
            {/*             }, */}
            {/*             scaleBeginAtZero: true */}
            {/*         }} width="600" height="400" /> */}
            {/* </div> */}
            <table className="w-full md:w-5/6 lg:w-2/3 mx-auto mb-12 text-center">
                <thead>
                    <tr>
                        <td>Year</td>
                        <td>Debt Service</td>
                        <td>Maintenance</td>
                        {/* <td>Road</td> */}
                        <td>Total Tax Rate</td>
                        <td>Order Levying Taxes</td>
                    </tr>
                </thead>
                <tbody>
                    {data.allStrapiTaxRate.nodes.map(rate => (
                        <tr key={rate.id}>
                            <td>{rate.year}</td>
                            <td>$ {(rate.debt_service_rate).toFixed(4)}</td>
                            <td>$ {(rate.maintenance_operations_rate).toFixed(4)}</td>
                            {/* <td>$ {(rate.road_rate).toFixed(2)}</td> */}
                            <td>$ {(rate.debt_service_rate + rate.maintenance_operations_rate + rate.road_rate).toFixed(4)}</td>
                            {rate.order_levying_taxes === null ? (<td></td>) : (<td className="not-prose"><a className="inline-block bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-800 hover:dark:bg-neutral-900 px-4 py-2 rounded-full leading-none" target="_blank" rel="noreferrer noopener" href={rate.order_levying_taxes.localFile.publicURL}>Order Levying Taxes – {rate.year}</a></td>)}
                        </tr>
                    ))}
                </tbody>
            </table>
        </Prose>
    )
}

export default TaxRate
